import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../Config/ApiConfig";
import { toast } from "react-toastify";

export const listPackageBenefits = createAsyncThunk(
  "package-benefits/list",
  async () => {
    try {
      const res = await Api.get(`/package-benefits`);
      if (res.data.status_code === 200) {
        return res.data.data;
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }
);

export const createPackageBenefit = createAsyncThunk(
  "package-benefits/create",
  async (payload) => {
    try {
      const res = await Api.post(`/package-benefits`, payload);
      if (res.data.status_code === 200) {
        toast.success(res.data.message);
        return res.data.data;
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }
);

export const updatePackageBenefit = createAsyncThunk(
  "package-benefits/update",
  async ({ id, data }) => {
    try {
      const res = await Api.put(`/package-benefits/${id}`, data);
      if (res.data.status_code === 200) {
        toast.success(res.data.message);
        return res.data.data;
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }
);

export const renamePackageBenefitSection = createAsyncThunk(
  "package-benefits/rename-section",
  async (payload) => {
    try {
      const res = await Api.put(`/package-benefits/section`, payload);
      if (res.data.status_code === 200) {
        toast.success(res.data.message);
        return res.data.data;
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }
);

export const swapPackageBenefitOrder = createAsyncThunk(
  "package-benefits/swap-order",
  async ({ id, direction }) => {
    try {
      const res = await Api.put(`/package-benefits/${id}/swap`, { direction });
      if (res.data.status_code === 200) {
        // toast.success(res.data.message); // Optional to avoid spamming toast on reorder
        return res.data.data;
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }
);

export const swapPackageBenefitSection = createAsyncThunk(
  "package-benefits/swap-section",
  async (payload) => {
    try {
      const res = await Api.put(`/package-benefits/section/swap`, payload);
      if (res.data.status_code === 200) {
        return res.data.data;
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }
);

export const deletePackageBenefit = createAsyncThunk(
  "package-benefits/delete",
  async (id) => {
    try {
      const res = await Api.delete(`/package-benefits/${id}`);
      if (res.data.status_code === 200) {
        toast.success(res.data.message);
        return { id };
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }
);
